<div class="measure-section" [ngClass]="{'no-bg': hasTransparentBackground(),
                                         'benchmark-performance-section': isSelectedInsightBenchmarkReport,
                                         'platforms-section': isSelectedExposurePlalformReport,
                                         'mention-timeline-section': isSelectedMentionTimelineReport,
                                         'performance-timeline-section': isSelectedTimeReport,
                                         'performance-kpi-section': isSelectedKPIReport}" *ngIf="data">
  <div class="header d-flex flex-row align-items-center" *ngIf="shouldDisplayTitle()" [ngClass]="{
  'best-performing-header': isSelectedBestPerformingReport,
  'benchmark-performance-header': isSelectedInsightBenchmarkReport,
  'channel-opportunity-header': isSelectedInsightOpportunityReport,
  'topic-insight-header': isSelectedSegmentationSegmentReport,
  'influencer-overview-header': isSelectedSegmentationInfluencerOverviewReport,
  'platforms-reach-header': isSelectedExposurePlalformReport
  }">
    <span>{{title}}</span>
    <achoo-icon-tooltip *ngIf="titleTooltip" [tooltipMsg]="titleTooltip"></achoo-icon-tooltip>
    <div class="sorting-feature" *ngIf="isSelectedBestPerformingReport && isEnableBestPerformingInfluencerSorting">
      <div class="icon-edit"></div>
      <achoo-filter-box
        [options]="sortList"
        [(model)]="selectedSortType"
        [makeSelectedItemOnTop]="true"
        (selectEvent)="onSelectSorting($event)"
        placement="bottom">
      </achoo-filter-box>
    </div>
  </div>

  <div class="measure-line-chart">
    <achoo-line-chart *ngIf="isSelectedTimeReport && data" [chartData]="data"></achoo-line-chart>
  </div>

  <kpi-report *ngIf="isSelectedKPIReport"
              [kpi]="data"
              [showMentionsKpi]="true"
              [showKpiStatus]="true">
  </kpi-report>

  <market-drill-down *ngIf="isSelectedLocalAreaReport && data" [markets]="data"></market-drill-down>

  <mention-timeline-report *ngIf="isSelectedMentionTimelineReport && data" [data]="data"></mention-timeline-report>

  <exposure-kpi-report *ngIf="isSelectedExposureKpiReport && data" [kpiReports]="data"></exposure-kpi-report>

  <platform-reache *ngIf="isSelectedExposurePlalformReport && data" [platforms]="data"
                   [activePlatforms]="getActivePlatformReach(data)">
  </platform-reache>

  <div *ngIf="isSelectedBestExposureReport && data" class="measure-section no-bg top-exposure-section">
    <div class="best-exposure-header header">
      <span>{{'INFLUENCER.insight.top_exposure.title' | translate}}</span>
    </div>
    <top-exposures [platformList]="platformList"
                   [topExposures]="data.topExposure" >
    </top-exposures>
  </div>

  <div *ngIf="isSelectedBestExposureReport && isSelectedBestExposureReport"><hr class="top-exposure-seperator" /></div>

  <div *ngIf="isSelectedBestExposureReport && data"
       class="measure-section no-bg best-performing-exposure-section">
    <best-performing-exposure [bestPerformingExposures]="data.bestPerformanceExposures" [showIndexNumber]="true" >
    </best-performing-exposure>
  </div>

  <influencer-overview-report *ngIf="isSelectedSegmentationInfluencerOverviewReport && data"
                              [segmentInfluencerOverview]="data" [pieChartCenter]="segmentInfluencerOverviewPieChartCenter">
  </influencer-overview-report>

  <topic-drill-down *ngIf="isSelectedSegmentationSegmentReport && data"
                    [topicSegmentReport]="data"
                    (changeSettingEvent)="onChangeSetting($event)"></topic-drill-down>

  <industry-drill-down-report *ngIf="isSelectedSegmentationIndustryReport && data"
                              [segementIndustry]="data" [pieCenter]="industryDrillDownReportPieCenter"
                              [pieSize]="industryDrillDownReportPieSize">
  </industry-drill-down-report>

  <channel-opportunities-report *ngIf="isSelectedInsightOpportunityReport && data"
                                [period]="period"
                                [industryIndex]="coIndex"
                                [data]="data"
                                (changeSettingEvent)="onChangeSetting($event)">
  </channel-opportunities-report>

  <average-benchmark-performance-report *ngIf="isSelectedInsightBenchmarkReport && data"
                                        [industryIndex]="bpIndex"
                                        [data]="data"
                                        (changeBenchmarkPerformanceSettings)="onChangeSetting($event)">
  </average-benchmark-performance-report>

  <best-performing-influencer *ngIf="isSelectedBestPerformingReport && data" [bestPerformingInfluencers]="data" [isSortedByReach]="isSortedByReach">
  </best-performing-influencer>

  <roi-report *ngIf="isSelectedRoiReport && data"
              [numberOfItemPerPage]="numberItemInRoiReport"
              [pageIndex]="pageIndex"
              [roiReport]="data" (changePage)="onChangeReportData($event)"></roi-report>

  <interaction-report *ngIf="isSelectedInteractionReport && data"
                      [pageIndex]="pageIndex"
                      [numOfItemPerPage]="numberItemForInteractionReport"
                      [data]="data" (changePage)="onChangeReportData($event)"></interaction-report>

  <oona-report [data]="data"
               [pageIndex]="pageIndex"
               [numOfItemPerPage]="numberItemForOonaReport"
               (changePage)="onChangeReportData($event)"
               *ngIf="isSelectedOonaReport"></oona-report>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-content/measure-content.component.html